import { render, staticRenderFns } from "./recordManage.vue?vue&type=template&id=23ab94fc&"
import script from "./recordManage.vue?vue&type=script&lang=js&"
export * from "./recordManage.vue?vue&type=script&lang=js&"
import style0 from "./recordManage.vue?vue&type=style&index=0&id=23ab94fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports